<script>export let title;
export let metaDescription;
export let metaImage;
</script>

<svelte:head>
  <meta name="twitter:card" content="summary_large_image" />

  {#if metaImage}
    <meta name="twitter:image" content="{metaImage.url}" />
  {/if}

  <meta name="twitter:title" content="{title}" />

  <meta name="twitter:description" content="{metaDescription}" />
</svelte:head>
